module.exports = __webpack_public_path__ + "static/img/1000.53cc0c49.png";